var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"background"},[_c('img',{attrs:{"src":_vm.imgSrc,"width":"100%","height":"100%","alt":""}})]),_c('div',{staticClass:"front"},[_c('div',{staticClass:"errorTitle"},[_vm._v("机器故障,暂停使用")]),_c('br'),_c('br'),_c('br'),_c('div',{staticClass:"errorReason"},[_vm._v("故障原因："+_vm._s(_vm.sharedState.errorMessage))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }